import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const SearchInputWrapper = styled.div<{ $width?: string }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: ${({ $width }) => $width ?? '100%'};
`;

export const SearchInputLabel = styled.label`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${({ theme }) => theme.atlas.semantic.color.type.default};
  overflow: hidden;
  text-overflow: ellipsis;
  height: 25px;
`;

export const SearchInputFieldRow = styled.div<{ $noLabelMargin?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${({ $noLabelMargin }) => ($noLabelMargin ? 0 : '8px')};
  border: 1px solid ${({ theme }) => theme.atlas.semantic.color.outline.default};
  border-radius: 3px;
  background: ${({ theme }) => theme.atlas.semantic.color.surface.default};
  padding: 7px 16px;
  gap: 8px;

  &:hover {
    border-color: ${({ theme }) => theme.atlas.semantic.color.outline.hover};
  }

  &:focus-within {
    outline: none;
    ${({ theme }) =>
      !theme.isVaultVariant
        ? `box-shadow: ${theme.atlas.semantic.shadow.focus};`
        : ''}
  }
`;

export const SearchInputInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${({ theme }) => theme.atlas.semantic.color.type.default};

  &::placeholder {
    color: ${({ theme }) => theme.atlas.semantic.color.type.disabled};
  }

  &:focus {
    outline: none;
  }

  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
`;

export const SearchIconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
